import { useState, useEffect } from "react";
import api from "../services/api";
export default function SalesReport() {


  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openSection, setOpenSection] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [itemReport, setItemReport] = useState([]);

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await api.get(
        `/reports/daily?fromDate=${fromDate}&toDate=${toDate}`
      );

      setReport(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  const loadTransactionReport = async () => {
  try {
    const res = await api.get(
      `/reports/transactions?fromDate=${fromDate}&toDate=${toDate}`
    );

    setTransactions(res.data);
  } catch (err) {
    console.error(err);
    alert("Failed to load transaction report");
  }
};


const loadItemReport = async () => {
  try {
    const res = await api.get(
      `/reports/itemised?fromDate=${fromDate}&toDate=${toDate}`
    );

    setItemReport(res.data);
  } catch (err) {
    console.error(err);
    alert("Failed to load item report");
  }
};


  useEffect(() => {
    loadReport(); // auto load today
  }, []);

  const formatMoney = (value) => {
  const num = Number(value || 0);
  return num.toFixed(2);
  };




  return (
    <div style={{ padding: 30 }}>

      <h2 style={{ fontSize: 22, fontWeight: 600 }}>
        Sales Report
      </h2>

      {/* DATE RANGE FILTER */}
      <div style={{ marginTop: 15, marginBottom: 25 }}>
        <input
          type="date"
          value={fromDate}
          onChange={e => setFromDate(e.target.value)}
          style={{
            padding: 8,
            borderRadius: 8,
            border: "1px solid #e5e7eb"
          }}
        />

        <span style={{ margin: "0 10px" }}>to</span>

        <input
          type="date"
          value={toDate}
          onChange={e => setToDate(e.target.value)}
          style={{
            padding: 8,
            borderRadius: 8,
            border: "1px solid #e5e7eb"
          }}
        />

        <button
          onClick={loadReport}
          style={{
            marginLeft: 10,
            padding: "8px 14px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 500
          }}
        >
          {loading ? "Loading..." : "Apply"}
        </button>
      </div>

      {report && (
        <>
          {/* SUMMARY CARDS */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 20,
            marginBottom: 30
          }}>

            <SummaryCard
              title="Total Orders"
              value={report.summary?.total_orders ?? 0}
            />

            <SummaryCard
              title="Gross Sales"
              value={`₹${formatMoney(report.summary?.gross_sales)}`}
            />

            <SummaryCard
              title="Total Discount"
              value={`₹${report.summary?.total_discount ?? 0}`}
            />

            <SummaryCard
              title="Net Sales"
              value={`₹${report.summary?.net_sales ?? 0}`}
            />

            <SummaryCard
              title="Average Bill"
              value={`₹${formatMoney(report.summary?.avg_bill) ?? 0}`}
            />
          </div>

          <CollapsibleSection
            title="Payment Breakdown"
            openSection={openSection}
            setOpenSection={setOpenSection}
          >
            {report.payments?.length > 0 ? (
              <Table
                headers={["Payment Mode", "Amount"]}
                rows={report.payments.map(p => [
                  p.tender_name,
                  `₹${p.amount}`
                ])}
              />
            ) : (
              <EmptyState message="No payments found" />
            )}
          </CollapsibleSection>

          <CollapsibleSection
            title="Category Summary"
            openSection={openSection}
            setOpenSection={setOpenSection}
            summaryText={`₹${formatMoney(
              report.category_summary?.reduce(
                (a, c) => a + Number(c.total_sales || 0),
                0
              )
            )}`}
          >
            {report.category_summary?.length > 0 ? (
              <Table
                headers={["Category", "Total Qty", "Total Sales"]}
                rows={report.category_summary.map(c => [
                  c.category_name,
                  c.total_qty,
                  `₹${c.total_sales}`
                ])}
              />
            ) : (
              <EmptyState message="No category data" />
            )}
          </CollapsibleSection>
          <CollapsibleSection
            title="Category & Size Breakdown"
            openSection={openSection}
            setOpenSection={setOpenSection}
            summaryText={`₹${formatMoney(
              report.category_size_summary?.reduce((a,c)=>a+Number(c.total_sales||0),0)
            )}`}
          >
          
            {report.category_size_summary?.length > 0 ? (
              <Table
                headers={["Category", "Item", "Size", "Qty", "Sales"]}
                rows={report.category_size_summary.map(r => [
                  r.category_name,
                  r.item_name,
                  r.size_name || "-",
                  r.total_qty,
                  `₹${r.total_sales}`
                ])}
              />
            ) : (
              <EmptyState message="No size data" />
            )}
          </CollapsibleSection>

            

            <CollapsibleSection
  title="Transaction Report"
  openSection={openSection}
  setOpenSection={setOpenSection}
>

  <button onClick={loadTransactionReport}>Load Transactions</button>

  {transactions.length > 0 && (
    <Table
      headers={[
        "Bill No",
        "Date",
        "Customer",
        "Mobile",
        "Order Type",
        "Gross",
        "Discount",
        "Net"
      ]}
      rows={transactions.map(t => [
        t.order_no,
        t.bill_date,
        t.customer_name || "-",
        t.customer_mobile || "-",
        t.order_type,
        `₹${formatMoney(t.total_amount)}`,
        `₹${formatMoney(t.discount_amount)}`,
        `₹${formatMoney(t.net_amount)}`
      ])}
    />
  )}

</CollapsibleSection>


<CollapsibleSection
  title="Itemised Report"
  openSection={openSection}
  setOpenSection={setOpenSection}
>

  <button onClick={loadItemReport}>Load Item Report</button>

  {itemReport.length > 0 && (
    <Table
      headers={[
        "Bill No",
        "Date",
        "Item",
        "Size",
        "Qty",
        "Amount"
      ]}
      rows={itemReport.map(i => [
        i.order_no,
        i.bill_date,
        i.item_name,
        i.size_name || "-",
        i.qty,
        `₹${formatMoney(i.final_amount)}`
      ])}
    />
  )}

</CollapsibleSection>






          <CollapsibleSection
            title="Item Sales"
            openSection={openSection}
            setOpenSection={setOpenSection}
          >
            {report.items?.length > 0 ? (
              <Table
                headers={["Item", "Total Qty", "Total Sales"]}
                rows={report.items.map(i => [
                  i.item_name,
                  i.total_qty,
                  `₹${i.total_sales}`
                ])}
              />
            ) : (
              <EmptyState message="No items sold" />
            )}
          </CollapsibleSection>

        </>
      )}
    </div>
  );
}

/* ================= REUSABLE COMPONENTS ================= */

const SummaryCard = ({ title, value }) => (
  <div style={{
    background: "#ffffff",
    padding: 20,
    borderRadius: 14,
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
  }}>
    <div style={{ fontSize: 13, color: "#6b7280" }}>
      {title}
    </div>
    <div style={{ fontSize: 22, fontWeight: 600, marginTop: 6 }}>
      {value}
    </div>
  </div>
);



const CollapsibleSection = ({ title, children, openSection, setOpenSection, summaryText }) => {

  const isOpen = openSection === title;

  return (
    <div style={{ marginBottom: 20 }}>
      <div
        onClick={() => setOpenSection(isOpen ? null : title)}
        style={{
          background: "#ffffff",
          padding: 14,
          borderRadius: 10,
          cursor: "pointer",
          fontWeight: 600,
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
        }}
      >
        <span>{title}</span>
        {summaryText && (
          <span style={{ fontSize: 13, color: "#6b7280" }}>
            {summaryText}
          </span>
        )}
      </div>

      {isOpen && (
        <div style={{ marginTop: 10 }}>
          {children}
        </div>
      )}
    </div>
  );
};

const Table = ({ headers, rows }) => {

  let totals = null;

  if (rows?.length > 0) {
    const qtyIndex = headers.findIndex(h => h.toLowerCase().includes("qty"));
    const salesIndex = headers.findIndex(h =>
      h.toLowerCase().includes("sales") ||
      h.toLowerCase().includes("amount")
    );

    let totalQty = 0;
    let totalSales = 0;

    rows.forEach(r => {
      if (qtyIndex >= 0) totalQty += Number(r[qtyIndex]) || 0;

      if (salesIndex >= 0) {
        const cleanValue = String(r[salesIndex]).replace(/[₹,]/g, "");
        totalSales += Number(cleanValue) || 0;
      }
    });

    totals = { totalQty, totalSales };
  }

  const formatMoney = (value) => {
    return Number(value || 0).toFixed(2);
  };

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 14,
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      overflowX: "auto"
    }}>
      <table style={{
        width: "100%",
        borderCollapse: "collapse"
      }}>
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th key={i} style={{
                textAlign: "left",
                padding: 12,
                borderBottom: "1px solid #f1f5f9",
                fontSize: 13
              }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} style={{
                  padding: 12,
                  borderBottom: "1px solid #f9fafb",
                  fontSize: 14
                }}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}

          {totals && (
            <tr style={{
              fontWeight: 600,
              background: "#f8fafc"
            }}>
              {headers.map((h, i) => {

                if (h.toLowerCase().includes("qty")) {
                  return (
                    <td key={i} style={{ padding: 12 }}>
                      {totals.totalQty}
                    </td>
                  );
                }

                if (
                  h.toLowerCase().includes("sales") ||
                  h.toLowerCase().includes("amount")
                ) {
                  return (
                    <td key={i} style={{ padding: 12 }}>
                      ₹{formatMoney(totals.totalSales)}
                    </td>
                  );
                }

                return (
                  <td key={i} style={{ padding: 12 }}>
                    Total
                  </td>
                );
              })}
            </tr>
          )}

        </tbody>
      </table>
    </div>
  );
};

const EmptyState = ({ message }) => (
  <div style={{
    background: "#ffffff",
    padding: 20,
    borderRadius: 14,
    boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
    color: "#6b7280"
  }}>
    {message}
  </div>
);